<header class="header">
  <div class="header__container">
    <!-- Left Section: Platform Name and Logo -->
    <div class="header__left" (click)="goToHome()" style="cursor: pointer;">
      <img
        src="assets/img/logos/LogoNegativo.png"
        alt="WeSportech Logo"
        class="header__wesportech-logo"
      />
      <span class="header__platform-name">Arena</span>
      <span class="header__separator">|</span>
      <img
        src="assets/img/logos/Recurso 4LogoNegativo.png"
        alt="Los Paisitas Logo"
        class="header__tenant-logo"
      />
    </div>

    <!-- User Actions -->
    <div class="header__actions">
      <!-- Language Selector -->
      <div class="header__lang-selector">
        <button
          class="lang-button"
          (click)="changeLanguage(currentLang === 'es' ? 'en' : 'es')"
          [title]="currentLang === 'es' ? 'Switch to English' : 'Cambiar a Español'">
          <span class="lang-flag">{{ getCurrentLanguage().flag }}</span>
          <span class="lang-code">{{ currentLang.toUpperCase() }}</span>
        </button>
      </div>

      <!-- User Profile -->
      <div class="header__user" *ngIf="currentUser">
        <button
          class="header__user-btn"
          (click)="toggleMenu()"
          [attr.aria-expanded]="isMenuOpen"
          aria-label="User menu">
          <div class="header__user-avatar">
            {{ getUserInitials() }}
          </div>
          <span class="header__user-name">{{ currentUser.name }}</span>
          <i class="pi pi-angle-down"></i>
        </button>

        <!-- Dropdown Menu -->
        <div class="header__menu" *ngIf="isMenuOpen" (click)="$event.stopPropagation()">
          <!-- User Info -->
          <div class="header__menu-header">
            <div class="header__menu-name">{{ currentUser.name }}</div>
            <div class="header__menu-email">{{ currentUser.email }}</div>
            <div class="header__menu-roles" *ngIf="currentUser.roles.length > 0">
              <span class="role-badge" *ngFor="let role of currentUser.roles">
                {{ role }}
              </span>
            </div>
          </div>

          <div class="header__menu-divider"></div>

          <!-- Menu Items -->
          <a href="#" class="header__menu-item" (click)="goToProfile($event)">
            <i class="pi pi-user"></i>
            <span>Mi Perfil</span>
          </a>

          <a href="#" class="header__menu-item" (click)="goToSettings($event)">
            <i class="pi pi-cog"></i>
            <span>Configuración</span>
          </a>

          <div class="header__menu-divider"></div>

          <!-- Logout -->
          <button class="header__menu-item" (click)="logout()">
            <i class="pi pi-sign-out"></i>
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
